import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]

import { computed, onMounted, ref } from "vue";

import { useFilesStore } from "@/stores/files.store";
import { useUIFilesStore } from "@/stores/ui-files.store";

import { useFileManager } from "@/composables/files-manager";

import Popup from "@/components/Popup.vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RenameAttachment',
  setup(__props) {

const uiFilesStore = useUIFilesStore();
const filesStore = useFilesStore();
const { renameAttachment } = useFileManager();

const newName = ref<string>("");
onMounted(() => {
  if (uiFilesStore.fileForRenaming) {
    newName.value = uiFilesStore.fileForRenaming.name;
  }
});
const isSubmitBtnEnabled = computed<boolean>(() => {
  return (
    !!uiFilesStore.fileForRenaming &&
    newName.value !== uiFilesStore.fileForRenaming.name &&
    newName.value !== "" &&
    !filesStore.areFilesUpdating
  );
});
const rename = () => {
  if (uiFilesStore.fileForRenaming) {
    renameAttachment(
      {
        id: uiFilesStore.fileForRenaming.id,
        name: newName.value
      },
      uiFilesStore.fileForRenaming
    ).then(() => {
      uiFilesStore.closeRenameAttachmentModal();
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "data-testing-modal-card": 'rename-file-card',
    onClosePopup: _unref(uiFilesStore).closeRenameAttachmentModal
  }, {
    header: _withCtx(() => _cache[1] || (_cache[1] = [
      _createElementVNode("h3", null, "Rename attachment", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("form", {
        id: "rename-attachment",
        onSubmit: _withModifiers(rename, ["prevent"])
      }, [
        _createVNode(RightSidebarTitle, { title: 'Enter a new attachment name:' }),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newName).value = $event)),
          disabled: _unref(filesStore).areFilesUpdating,
          "data-testing": "rename-file-input",
          type: "text"
        }, null, 8, _hoisted_1), [
          [
            _vModelText,
            newName.value,
            void 0,
            { trim: true }
          ]
        ])
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        disabled: !isSubmitBtnEnabled.value,
        class: "btn-1 full-width",
        "data-testing": "rename-file-btn",
        form: "rename-attachment",
        type: "submit"
      }, " Rename ", 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["onClosePopup"]))
}
}

})